import React from "react";
import { styled } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import classes from "./Declaration.module.css";
import CustomTextInput from "../../../components/Input/Text/TextInput";
import { useTranslation } from "../../../I18n/Languages/LanguageContext";

export default function Declaration({ formData, updateFormData }) {
  const { t } = useTranslation();
  const CustomCheckbox = styled(Checkbox)(() => ({
    padding: "0px",
    "&.Mui-checked": {
      color: "#DB0035",
      padding: "0px",
    },
  }));

  return (
    <div className={classes.personalForm}>
      <div className={classes.subTitle}>{t("declaration_text")}</div>
      <div className={classes.checkboxWrapperFlex}>
        <div className={classes.checkboxWrapper}>
          <CustomCheckbox
            checked={formData.dataProtectionAgreement}
            onChange={(e) => updateFormData("dataProtectionAgreement", e.target.checked)}
          />
          <div className={classes.checkboxText}>{t("data_protection_agreement")}</div>
        </div>
        <div className={classes.checkboxWrapper}>
          <CustomCheckbox
            checked={formData.verificationAuthorization}
            onChange={(e) => updateFormData("verificationAuthorization", e.target.checked)}
          />
          <div className={classes.checkboxText}>{t("verification_authorization")}</div>
        </div>
      </div>
      <CustomTextInput
        name="fullName"
        label={t("full_name_declaration")}
        topLabel={t("full_name_declaration")}
        // value={formData.fullName}
        onChange={(e) => updateFormData("fullName", e.target.value)}
      />
    </div>
  );
}
